import React from 'react';
import cn from 'classnames';
import Image from '@framework/router/Next/Image';
import baseStyles from '@/dataroom/ui/components/Landing/dealvdr/tenantDealvdrStyles.module.scss';
import BookDemoButton from '@/dataroom/ui/common/BookDemoButton';
import GetStartedButton from '@/dataroom/ui/components/Landing/common/GetStartedButton';
import spacesStyles from '@dealroadshow/uikit-styles/helpers/spaces.module.scss';
import Support from '@framework/ui/Pages/Landing/Sections/Support';
import Features from '@/dataroom/ui/components/Landing/Legacy/Sections/Features';
import LearnMore from '../LearnMore';
import FooterPattern from '@framework/ui/Pages/Landing/Sections/FooterPattern';
import { homeConfig } from './constants';
import introAnimation from './assets/introAnimation.webp';
// Patterns
import introPattern from '@/dataroom/ui/assets/introPattern.svg';
import supportStamp from './assets/supportStamp.svg';
// Styles
import commonHomeStyles from '@/dataroom/ui/components/Landing/common/homeSection.module.scss';
import styles from './home.module.scss';

const Home = () => (
  <div className={ styles.homeWrp }>
    <div className={ cn(commonHomeStyles.intro, styles.intro) }>
      <div className={ commonHomeStyles.introContainer }>
        <div className={ commonHomeStyles.introContent }>
          <h1 className={ commonHomeStyles.introTitle }>Streamline your<br />17g-5 compliance</h1>

          <div className={ cn(commonHomeStyles.introDescription, styles.description) }>
            <p>
              <strong>17g5.com</strong> is a secure and cost-effective virtual data room
              for SEC Rule 17g-5 compliance. It’s used by hundreds of issuers
              in the US ABS market, all major underwriters and rating agencies
              and is backed by <strong>fanatical 24x7 support</strong>.
            </p>
            <p>Book a demo or get started now.</p>
          </div>

          <BookDemoButton legacy />
          <GetStartedButton className={ cn(baseStyles.secondaryBtn, spacesStyles.mrn) } />
        </div>
        <div className={ commonHomeStyles.introAnimation }>
          <div className={ commonHomeStyles.introAnimationContainer }>
            <Image
              src={ introAnimation.src }
              width={ 608 }
              height={ 460 }
              title={ 'Intro' }
              alt={ 'Intro' }
            />
          </div>
        </div>
      </div>
      <div className={ commonHomeStyles.introPattern }>
        <img src={ introPattern.src } />
      </div>
    </div>
    <Features { ...homeConfig.features } />
    <div className={ cn(commonHomeStyles.support, styles.support) }>
      <Support />
      <div className={ commonHomeStyles.supportStamp }>
        <img src={ supportStamp.src } />
      </div>
    </div>
    <LearnMore />
    <FooterPattern />
  </div>
);

export default Home;
